<template>
  <div class="Fuell-Card Fuell-Card--graphics">
    <div class=" filter-box ">
      <div class="input--block input--block--margin mr-2">
        <div class="label form--label">
          {{$t('dashboard_selector_group_by').toUpperCase()}}
        </div>

        <div class="multiselect-filter">
          <multiselect
            :options="delimitedBySelectorOptions"
            :label="'label'"
            :trackBy="'id'"
            :selectLabel="''"
            :allowEmpty="false"
            :placeholder="$t('dashboard_selector_group_by')"
            :showLabels="false"
            v-model="selectedDelimitedBy"
            @input="setFilters"
          >
            <div
              class="caret"
              slot="caret"
              slot-scope="{ toggle }"
              @mousedown.prevent.stop="toggle"
            >
              <i
                class="Ctrl Ctrl--16"
                aria-hidden="true"
              >
                <svg
                  focusable="false"
                  aria-hidden="true"
                  aria-label="Edit"
                >
                  <use xlink:href="#dropdown-icon"></use>
                </svg>
              </i>
            </div>

          </multiselect>
        </div>

      </div>
      <div class="input--block input--block--margin mr-2">
        <label
          for=""
          class="form--label"
        >{{$t('dashboard_graphic_date_selector_filter').toUpperCase()}}</label>

        <div class="date-selector-filter">
          <date-select @selectDate="timeSelectorHandler"></date-select>
        </div>
      </div>
      <div class="input--block input--block--margin">
        <label
          for=""
          class="form--label"
        >{{$t('dashboard_selector_group_by').toUpperCase()}}</label>

        <div class="multiselect-filter">
          <multiselect
            :options="groupBySelectorOptions"
            :label="'label'"
            :trackBy="'id'"
            :selectLabel="''"
            :allowEmpty="false"
            :placeholder="$t('dashboard_selector_group_by')"
            :showLabels="false"
            v-model="selectedGroupBy"
            @input="setFilters"
          >
            <div
              class="caret"
              slot="caret"
              slot-scope="{ toggle }"
              @mousedown.prevent.stop="toggle"
            >
              <i
                class="Ctrl Ctrl--16"
                aria-hidden="true"
              >
                <svg
                  focusable="false"
                  aria-hidden="true"
                  aria-label="Edit"
                >
                  <use xlink:href="#dropdown-icon"></use>
                </svg>
              </i>
            </div>
          </multiselect>
        </div>
      </div>
    </div>
    <div>
      <div class="d-flex flex-column my-3">
        <span class="label form--label"> {{$t('dashboard_insight_expense_word').toUpperCase()}} {{ generateSelectedTimePeriodLabel().toUpperCase()}}</span>
        <span class="total-spent"> {{totalSpent | currency('€', 2, {
            symbolOnLeft: false,
            thousandsSeparator: '.',
            decimalSeparator: ','
          })}}</span>
      </div>
      <bar-chart
        v-if="loaded"
        :chart-data="chartData"
        :options="options"
        :width="graphicWidth"
        :height="graphicHeight"
        ref="barChart"
      > </bar-chart>
      <div
        class="w-100 h-100 d-flex justify-content-center"
        v-else
      >
        <spinner />
      </div>
    </div>
    <dashboard-time-selector-modal
      v-if="showCustomDateRangeFilterModalFlag"
      :open.sync="showCustomDateRangeFilterModalFlag"
      @accept="setCustomDateRange"
    ></dashboard-time-selector-modal>
  </div>
</template>

<script>
import BarChart from '@/components/Commons/Charts/BarChart'
import Spinner from '@/components/Commons/Spinner'
import Multiselect from 'vue-multiselect'
import DateSelect from '../../../components/Commons/Forms/DateSelect.vue'
import transactionPeriodsMixin from '@/modules/transactions/_mixins/_transactionPeriods'
import DashboardGraphicsBudgetsManagerMixin from '../_mixins/DashboardGraphicsBudgetsManagerMixin'
import DashboardGraphicsCategoriesManagerMixin from '../_mixins/DashboardGraphicsCategoriesManagerMixin'
import DashboardGraphicsExpenseTypeManagerMixin from '../_mixins/DashboardGraphicsExpenseTypeManagerMixin'
import { regularBarChartConfiguration, stackedBarChartConfiguration } from '@/components/Commons/Charts/_utils/BarChartConfig'
const DashboardTimeSelectorModal = () => import('./DashboardTimeSelectorModal')
export default {
  name: 'DashboardGraphicCard',
  components: { BarChart, Multiselect, DashboardTimeSelectorModal, Spinner, DateSelect },
  mixins: [DashboardGraphicsBudgetsManagerMixin, DashboardGraphicsCategoriesManagerMixin, DashboardGraphicsExpenseTypeManagerMixin, transactionPeriodsMixin],
  computed: {
    chartOptions () {
      return this.stacked ? this.stackedBarChartConfiguration : this.regularBarChartConfiguration
    },

    expenseDashboardData () {
      return this.$store.getters['DashboardStore/expenseDashboardData']
    },
    stackedBarChartConfiguration () {
      return stackedBarChartConfiguration
    },
    regularBarChartConfiguration () {
      return regularBarChartConfiguration
    }
  },
  props: {
    id: {
      type: String
    },
    budgetDetailMode: {
      type: Boolean,
      default: false
    },
    budgetId: {
      type: [String, Number],
      default: 0
    },
    graphicWidth: {
      type: Number,
      default: 300
    },
    graphicHeight: {
      type: Number,
      default: 330
    },
    stacked: {
      type: Boolean,
      default: false
    },
    agrupationType: {
      type: String,
      default: 'BUDGETS'
    }

  },
  data () {
    return {
      loaded: false,
      chartData: null,
      filters: {
        'delimitedBy': this.budgetDetailMode ? 'BUDGETS' : 'EXPENSE_TYPE',
        'groupBy': 'month'
      },
      options: {},
      timeRangeSelector: [],
      selectedTimeRange: null,
      showCustomDateRangeFilterModalFlag: false,
      groupBySelectorOptions: [],
      delimitedBySelectorOptions: [],
      selectedGroupBy: null,
      selectedDelimitedBy: null,
      totalSpent: 0
    }
  },
  async created () {
    this.selectedTimeRange = this.periods.find(el => el.id === 'historic')
    this.timeSelectorHandler(this.selectedTimeRange)
    this.generateDelimitedBySelectorData()
    if (this.budgetDetailMode) {
      this.selectedDelimitedBy = this.delimitedBySelectorOptions.find(el => el.delimitedBy === 'BUDGETS')
    } else {
      this.selectedDelimitedBy = this.delimitedBySelectorOptions.find(el => el.delimitedBy === 'EXPENSE_TYPE')
    }
    await this.setFilters()
  },
  methods: {
    async setFilters () {
      this.loaded = false
      this.generateGroupSelectorData()
      this._initializeFilters()

      await this.$store.dispatch('DashboardStore/setExpenseDataFilters', { filters: { ...this.filters } })
      this.options = { ...this.chartOptions }
      this.setChartData()
      this.loaded = true
    },
    generateSelectedTimePeriodLabel () {
      if (this.selectedTimeRange && this.selectedTimeRange.code === 'custom') {
        let startDate = new Date(this.$moment.utc(this.selectedTimeRange.dateStart).format())
        let endDate = new Date(this.$moment.utc(this.selectedTimeRange.dateEnd).format())
        return ` ${this.$t('dashboard_graphic_date_selector_range_from')} ` + this.$i18n.d(startDate, 'long') + ` ${this.$t('dashboard_graphic_date_selector_range_to')} ` + this.$i18n.d(endDate, 'long')
      }

      if (this.selectedTimeRange && this.selectedTimeRange.code === 'predefined') {
        return this.selectedTimeRange.label
      }
      return ''
    },
    setChartData () {
      const chartData = this.$store.getters['DashboardStore/expenseDashboardData']
      const chartLabels = this.generateChartDataLabels(chartData, this.filters.groupBy)
      const chartDataSet = chartData.map(el => (Number.parseFloat((Math.round(el.totalAmount * 100) / 100).toFixed(2))))
      this.totalSpent = chartDataSet.length > 0 ? chartDataSet.reduce((previous, current) => Number.parseFloat(previous) + Number.parseFloat(current)) : 0
      this.chartData = {
        labels: [...chartLabels],
        datasets: []
      }
      this.generateChartDataDataSet()
    },
    generateChartDataLabels (chartData, groupByType) {
      if (groupByType === 'month') {
        return chartData.map(el => {
          return this.$i18n.d(new Date(this.$moment.utc(el.dateSum).format()), 'month')
        })
      }
      return chartData.map(el => { return this.$i18n.d(new Date(this.$moment.utc(el.dateSum).format()), 'short') })
    },
    timeSelectorHandler (event) {
      this.selectedTimeRange.dateStart = event.filter['date[after]']
      this.selectedTimeRange.dateEnd = event.filter['date[before]']
      this.selectedTimeRange.label = this.$t('date_picker_select_range_selector_range_selected', { startDate: event.filter['date[after]'], endDate: event.filter['date[before]'] })
      this.setFilters()
    },
    generateDelimitedBySelectorData () {
      const delimitedByExpenseType = {
        id: 1,
        label: this.$t('dashboard_graphic_group_selector_delimited_by_expense_type'),
        delimitedBy: 'EXPENSE_TYPE'
      }
      const delimitedByBudget = {
        id: 2,
        label: this.$t('dashboard_graphic_group_selector_delimited_by_budget'),
        delimitedBy: 'BUDGETS'

      }
      const delimitedbyCategory = {
        id: 3,
        label: this.$t('dashboard_graphic_group_selector_delimited_by_category'),
        delimitedBy: 'CATEGORIES'

      }
      this.delimitedBySelectorOptions = [delimitedByExpenseType, delimitedByBudget, delimitedbyCategory]
    },
    generateGroupSelectorData () {
      const groupByDays = {
        id: 1,
        label: this.$t('dashboard_graphic_group_selector_group_by_days'),
        groupBy: 'day'
      }
      const groupByMonths = {
        id: 2,
        label: this.$t('dashboard_graphic_group_selector_group_by_month'),
        groupBy: 'month'
      }
      this.groupBySelectorOptions = [groupByDays, groupByMonths]
    },
    generateChartDataDataSet () {
      if (this.selectedDelimitedBy?.delimitedBy === 'CATEGORIES') {
        this.chartData.datasets = this.generateCategoriesDataAgrupation()
        return
      }

      if (this.selectedDelimitedBy?.delimitedBy === 'BUDGETS') {
        this.chartData.datasets = this.generateBudgetDataset()
        return
      }
      // Default = EXPENSE_TYPE
      // T TODO implement expense type
      if (this.selectedDelimitedBy?.delimitedBy === 'EXPENSE_TYPE') {
        this.chartData.datasets = this.generateExpenseTypeDataAgrupation()
      }
    },
    _initializeFilters () {
      if (this.selectedTimeRange) {
        this.filters.dateStart = this.selectedTimeRange.dateStart
        this.filters.dateEnd = this.selectedTimeRange.dateEnd
      }

      if (this.selectedGroupBy) {
        this.filters.groupBy = this.selectedGroupBy.groupBy
      } else {
        this.selectedGroupBy = this.groupBySelectorOptions.find(el => el.id === 2)
        this.filters.groupBy = this.selectedGroupBy.groupBy
      }

      if (this.selectedDelimitedBy) {
        this.filters.delimitedBy = this.selectedDelimitedBy.delimitedBy.toUpperCase()
      }

      this.filters.budgetType = 'normal'
      // this.filters.delimitedBy = this.agrupationType === 'BUDGETS' ? 'BUDGETS' : 'CATEGORIES'

      if (this.budgetDetailMode && this.budgetId) {
        this.filters.budgetId = this.budgetId
      }
    }
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
.Fuell-Card {
  height: 515px;
  margin-top: 3px;
}
.Fuell-Card--title {
  margin-bottom: 15px;
}
.input--block--margin {
  margin-top: 5px;
  margin-bottom: 0px;
}

.total-spent {
  font-weight: 600;
  font-size: 20px;
}

.filter-box {
  display: flex;
  justify-content: space-between;
}

@media screen and (max-width: 910px) {
  .filter-box {
    flex-direction: column;
  }
}

.multiselect-filter >>> * {
  font-size: 13px;
}
.multiselect-filter >>> .multiselect .multiselect__single {
  max-width: 100%;
}

.date-selector-filter >>> .date-select-filter-selector {
  width: 100%;
  height: 46px;
}
</style>
